// style and assets from component imports
import './Avatar.css';
import user from '../../Assets/Image/user.svg'

const Avatar = ({ src, alt, size }) => {
    // Use default avatar if src is null or undefined
    const avatarSrc = src || user; 
  return (
    <div className={`avatar ${size}`}>
      <img src={avatarSrc} alt={alt} />
    </div>
  )
}

export default Avatar